import { render, staticRenderFns } from "./input-file-classic.vue?vue&type=template&id=03001604&scoped=true"
import script from "./input-file-classic.ts?vue&type=script&lang=ts&external"
export * from "./input-file-classic.ts?vue&type=script&lang=ts&external"
import style0 from "./input-file-classic.vue?vue&type=style&index=0&id=03001604&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03001604",
  null
  
)

export default component.exports